import type React from 'react';

import { m } from 'framer-motion';

const variants = {
  hidden: { height: 0, opacity: 0, overflow: 'hidden', y: -50 },
  visible: {
    height: '100%',
    opacity: 1,
    overflow: 'visible',
    transition: {
      damping: 20,
      duration: 0.1,
      stiffness: 100,
      type: 'spring',
    },
    y: 0,
  },
};

export interface MotionFadeInFromTopProps {
  children: React.ReactNode;
}
const MotionFadeInFromTop = ({ children }: MotionFadeInFromTopProps) => {
  return (
    <m.div variants={variants} animate="visible" initial="hidden">
      {children}
    </m.div>
  );
};

export default MotionFadeInFromTop;
